<template>
  <div class="remote-footer-iframe-wrapper" :style="wrapperStyle">
    <iframe
      v-if="computedUrl"
      :src="computedUrl"
      class="remote-footer-iframe"
      :title="title"
      loading="lazy"
      referrerpolicy="no-referrer"
      sandbox="allow-same-origin allow-forms allow-popups allow-scripts"
      @load="onLoad"
      @error="onError"
    ></iframe>
    <div v-else class="text-sm text-red-500">Nessun URL footer configurato.</div>
    <div v-if="debug" class="mt-2 text-xs text-gray-500">
      <span v-if="loaded">[IframeRemoteFooter] Caricato</span>
      <span v-else-if="error">[IframeRemoteFooter] Errore caricamento</span>
      <span v-else>[IframeRemoteFooter] In attesa...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IframeRemoteFooter',
  emits: ['load','error','height'],
  props: {
    url: { type: String, default: '' },
    title: { type: String, default: 'Footer remoto' },
  height: { type: [String, Number], default: 1000 },
  maxHeight: { type: [String, Number], default: 1600 },
  autoHeight: { type: Boolean, default: true },
    debug: { type: Boolean, default: false },
    allowResizeMessages: { type: Boolean, default: true },
    resizeMessageOrigin: { type: String, default: '' },
    /* Se impostato a false riattiva l'uso della variabile env VUE_APP_REMOTE_FOOTER_IFRAME_URL */
    ignoreEnv: { type: Boolean, default: true }
  },
  data(){
    return {
      loaded: false,
      error: false,
      currentHeight: this.height
    };
  },
  computed: {
    computedUrl(){
      const fixed = 'https://powergiobsrl.it/apus_footer/footer-1/';
      if (this.url) return this.url; // prop ha priorità massima
      if (!this.ignoreEnv){
        const envUrl = (process.env.VUE_APP_REMOTE_FOOTER_IFRAME_URL || '').trim();
        if (envUrl) return envUrl;
      }
      return fixed;
    },
    wrapperStyle(){
      const h = Number(this.currentHeight) || Number(this.height) || 1000;
      const max = Number(this.maxHeight) || 1600;
      const finalH = Math.min(h, max);
      return {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        '--footer-iframe-height': finalH + 'px'
      };
    }
  },
  mounted(){
    if(this.allowResizeMessages && this.autoHeight){
      window.addEventListener('message', this.onMessage, false);
    }
  },
  beforeUnmount(){
    if(this.allowResizeMessages && this.autoHeight){
      window.removeEventListener('message', this.onMessage, false);
    }
  },
  methods: {
    onLoad(){
      this.loaded = true;
      if(this.debug) console.info('[IframeRemoteFooter] load event');
      this.$emit('load');
    },
    onError(){
      this.error = true;
      if(this.debug) console.warn('[IframeRemoteFooter] errore caricamento iframe');
      this.$emit('error');
    },
    onMessage(e){
      if(this.resizeMessageOrigin && e.origin !== this.resizeMessageOrigin) return;
      if(!e.data) return;
      try {
        const msg = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
        if(msg && msg.type === 'footer:height' && msg.height && this.autoHeight){
          const h = parseInt(msg.height, 10);
            if(!isNaN(h) && h > 100 && h < 5000){
              this.currentHeight = h;
              if(this.debug) console.info('[IframeRemoteFooter] Altezza aggiornata', h);
              this.$emit('height', h);
            }
        }
      } catch(_) { /* ignore */ }
    }
  }
};
</script>

<style scoped>
.remote-footer-iframe {
  border: 0;
  width: 100%;
  height: var(--footer-iframe-height, 560px);
  display: block;
  background: transparent;
  overflow: hidden; /* tenta di evitare scrollbar interne (alcuni UA ignorano) */
  scrollbar-width: none; /* Firefox */
}
.remote-footer-iframe::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
</style>

<!-- Nota: la reale rimozione della scrollbar verticale dipende dal contenuto remoto.
Se la pagina remota non invia postMessage con l'altezza, l'autoHeight userà l'altezza iniziale.
Per risultati ottimali, far emettere dal remoto:
parent.postMessage(JSON.stringify({type:'footer:height',height:document.body.scrollHeight}), '*') -->
